"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.descSort = exports.ascSort = exports.getPercentageDiff = exports.formatPrice = exports.formatPriceRange = exports.round = exports.minmax = exports.applyRate = void 0;
function applyRate(amount, rate) {
    return rate ? Math.round(amount * (1 + rate / 100)) : amount;
}
exports.applyRate = applyRate;
function minmax(number, min = -Infinity, max = Infinity, roundToDecimalPlaces) {
    const ranged = Math.min(Math.max(number, min), max);
    return typeof roundToDecimalPlaces === 'number'
        ? round(ranged, roundToDecimalPlaces)
        : ranged;
}
exports.minmax = minmax;
function round(number, decimalPlaces = 0) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor;
}
exports.round = round;
const defaultOptions = (options) => (Object.assign({ currency: 'PLN' }, options));
const getPriceFormatter = (options) => {
    const { locale, currency } = defaultOptions(options);
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
    });
};
function formatPriceRange(min, max, options) {
    return getPriceFormatter(options).formatRange(min / 100 || 0, max / 100 || 0);
}
exports.formatPriceRange = formatPriceRange;
function formatPrice(number, options) {
    return getPriceFormatter(options).format(number / 100 || 0);
}
exports.formatPrice = formatPrice;
function getPercentageDiff(price, discount) {
    return Math.round((1 - discount / price) * 100);
}
exports.getPercentageDiff = getPercentageDiff;
function ascSort(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
exports.ascSort = ascSort;
function descSort(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
exports.descSort = descSort;
